import { VIDEOS, CLINIC } from "@/data/clinic";
import SEOHead from "@/components/SEOHead";
import { Play } from "lucide-react";
import { Link } from "react-router-dom";

export default function Videos() {
  return (
    <div data-testid="videos-page">
      <SEOHead
        title="Educational Videos | Dr. Ashutosh Mishra — Diabetes & Endocrinology"
        description="Watch educational videos on diabetes, thyroid, PCOS, obesity and hormonal health from Dr. Ashutosh Mishra, senior endocrinologist in Varanasi."
        path="/videos"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Videos", url: "/videos" },
        ]}
      />
      <section className="bg-gradient-to-br from-green-50/60 via-white to-green-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <nav className="text-xs text-slate-500 mb-3">
            <Link to="/" className="hover:text-green-700">Home</Link> <span className="mx-1.5">/</span> <span className="text-slate-700">Videos</span>
          </nav>
          <div className="text-xs uppercase tracking-[0.22em] text-green-700 font-medium">Educational videos</div>
          <h1 className="font-poppins font-semibold text-4xl sm:text-5xl text-slate-900 mt-3 leading-tight">Health Videos by {CLINIC.doctorName}</h1>
          <p className="text-slate-600 text-lg mt-4 max-w-3xl">
            Short, practical videos explaining diabetes, thyroid, PCOS, obesity, hormonal disorders and kidney protection — in plain language.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {VIDEOS.map((v, i) => (
            <a
              key={i}
              href={`https://www.youtube.com/watch?v=${v.youtubeId}`}
              target="_blank"
              rel="noreferrer"
              data-testid={`video-card-${i}`}
              className="group bg-white border border-slate-100 rounded-3xl overflow-hidden hover:shadow-md transition"
            >
              <div className="relative aspect-video overflow-hidden">
                <img src={v.thumb} alt={v.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-black/30 grid place-items-center">
                  <div className="w-14 h-14 rounded-full bg-white/95 grid place-items-center text-green-700">
                    <Play className="w-6 h-6 fill-green-700" />
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded">{v.duration}</div>
              </div>
              <div className="p-5">
                <div className="text-xs text-green-700 uppercase tracking-wider">{v.category}</div>
                <h2 className="font-poppins font-semibold text-lg text-slate-900 mt-1 leading-snug">{v.title}</h2>
              </div>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
